import Action from "./Component/Action";
import Date from "./Component/Date";
import Dest from "./Component/Dest";
import { Grid, useTheme } from "@mui/material";
import Pagination from "components/Pagination";
import Prices from "./Component/Prices";
import Table from "components/Table";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import Type from "./Component/Type";
import UsdtVal from "./Component/UsdtVal";
import Wallet from "./Component/Wallet";
import { useSelector } from "react-redux";

const headers = [
  {
    name: "Action",
    key: "action",
    align: "left",
  },
  {
    name: "Src / Dst",
    key: "dest",
    align: "center",
  },
  {
    name: "Broker",
    key: "broker",
    align: "center",
  },
  {
    name: "Type",
    key: "type",
    align: "center",
  },
  {
    name: "Amount / Total Price",
    key: "prices",
    align: "center",
  },
  {
    name: "Date",
    key: "date",
    align: "center",
  },
  {
    name: "ٰValue of transaction time",
    key: "usdtVal",
    align: "center",
  },
];

function TablePortfolioTradeCoinList() {
  const theme = useTheme();

  const portfolioSingleTradeList = useSelector(
    (state) => state.portfolio.portfolioSingleTradeList
  );

  const formattedDataList = portfolioSingleTradeList?.data?.map((data) => {
    return {
      data: data,
      background:
        data?.side === "Buy"
          ? theme.palette.modules.colorRowTableBuy
          : theme.palette.modules.colorRowTableSell,
      action: <Action data={data} />,
      dest: <Dest data={data} />,
      broker: <Wallet data={data} />,
      type: <Type data={data} />,
      prices: <Prices data={data} />,
      date: <Date data={data} />,
      usdtVal: <UsdtVal data={data} />,
      color:
        data?.side === "Buy"
          ? `${theme.palette.success.main}10`
          : `${theme.palette.error.main}10`,
    };
  });

  return (
    <Grid container>
      <Grid item xs={12} marginBottom={2}>
        {portfolioSingleTradeList?.data ? (
          <Table
            headers={headers}
            items={formattedDataList}
            hideBorders={true}
          />
        ) : (
          <TableSkeleton />
        )}
      </Grid>

      <Grid item xs={12}>
        <Pagination
          perPage={portfolioSingleTradeList?.pageSize}
          count={portfolioSingleTradeList?.totalPages}
          onChange={() => { }}
        />
      </Grid>
    </Grid>
  );
}

export default TablePortfolioTradeCoinList;
